/* eslint-disable max-len */
import cx from 'clsx';
// styles
import { useStyles } from './shared/styles';

const ScratchpadFilled = ({ className, color, onClick }) => {
  const classes = useStyles();

  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path d="M3 0V3H0V5H3V8H5V5H8V3H5V0H3ZM10 4C10 7.31371 7.31371 10 4 10C3.29873 10 2.62556 9.8797 2 9.6586V19.0066C2 19.5551 2.44694 20 2.99826 20H13V14C13 13.45 13.45 13 14 13H20V2.9985C20 2.44749 19.5552 2 19.0066 2H9.6586C9.8797 2.62556 10 3.29873 10 4ZM20 15L15 19.997V15H20Z" fill={color} />
    </svg>
  );
};

export default ScratchpadFilled;
